<template>
  <!-- calculator section -->
	<div class="calc-outer-container">
		<div class="container">
			<div class="row">
				<div class="col-lg-10 offset-lg-1">
					<div class="row align-items-center">
						<div class="col-sm-5">
							<div class="calculator-image-box">
								<img loading="lazy" src="img/goals-calc-image.webp" width="229" height="322" alt="Calculator to know your goal amount">
							</div>
						</div>
						<div class="col-sm-7">
							<div class="goals-calc-container">
								<div class="steps-heading">
									<h2 class="hf_heading02">Tell us what you require</h2>
								</div>
								<!-- calculator section -->
								<div class="goals-calculator-box captcha-div">
			            <div class="calculator">
			  						<form action="show-goal-result" method="post" id="showOtherResult">
  										<input type="hidden" v-model="_token" name="_token">
  										<input type="hidden" v-model="goalTopTextPass" name="goalTopText">
  										<input type="hidden" v-model="goalTextPass" name="goalText">
  										<input type="hidden" v-model="goalTypePass" name="goalType">
			  							<div class="form-group dynamic-input">
			  								<span class="plane-text">I need {{ (goalTypePass == "HEALTH" ? 'a' : 'an')}} {{ goalTopTextPass }} corpus</span>
			  							</div>
			  							<div class="form-group dynamic-input">
			  								<label>of<span class="inr-symbol hf_dark">&#8377;</span></label>
			  								<input type="text" id="amount" name="amountReqd" v-model="amountReqd" class="restDot numbersonly" :class="amountReqdMClass" @keyup="resetCalculation()" placeholder="5,00,000" min="0" maxlength="14" required>

			  								<span class="plane-text">in</span>
												<input type="number" id="year" name="yearReqd" v-model="yearReqd" class="restDot numbersonly width-dynamic"  :class="yearReqdMClass" @keyup="resetCalculation()" placeholder="5" min="0" maxlength="2" @input="updateYearVal()" required>

												<span class="plane-text">years.</span>
			  							</div>
			  							<VueRecaptcha 
                        sitekey="6Ldr460jAAAAAO6wyw1mVTSg_2T2Zp9WTkO9SL_9" 
                        ref="recaptcha"
                        size="invisible"
                        :load-recaptcha-script="true" 
                        @verify="recaptchaVerified" 
                        @expired="resetCaptcha">
                      </VueRecaptcha>
			  							<div class="notification-message">
				  							<p v-show="showError" class="errorMessage inflation-text hf_bodytext02">
				  								<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
				            			{{ showErrorText }}
				          			</p>
				          		</div>
			  							<div class="button-container">
			  								<button type="button" class="btn-primaryNoIcon lg-primarynoIcon" @click.stop="showResult()">Know more</button>
			  							</div>
			  						</form>
			  					</div>
			          </div>
								<!-- end calculator section -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- end calculator section -->
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
export default {
	components: {
    VueRecaptcha
  },
  created() {},
  data() {
    return {
    	_token : this.$token,
    	yearReqd: '',
    	amountReqd: '',
    	amountReqdMClass: '',
    	yearReqdMClass: '',
    	mandatoryClassName: 'redunderline',
    	showErrorText: '',
    	showError: false,
    	goalTopTextPass: '',
    	goalTextPass: '',
    	goalTypePass: '',
    	recaptchaToken:'',
    };
  },
  props: {
  	goalTopText: { type:String, default:''},
  	goalText: { type:String, default:''},
  	goalType: { type:String, default:'OTHR'},
  },
  watch: {
	amountReqd(){
		var res =  this.formatAmount(this.amountReqd)
		this.amountReqd = res;
    },
  },
  mounted(){
  	// console.log("goalTopText="+this.goalTopText);
  	// console.log("goalText="+this.goalText);
  	// console.log("goalType="+this.goalType);
  	this.goalTopTextPass = this.goalTopText;
  	this.goalTextPass = this.goalText;
  	this.goalTypePass = this.goalType;
  },
  methods: {
    updateYearVal: function(){
      var element = event.target;
      var maxlength = element.getAttribute('maxlength');
      if(this.yearReqd.toString().length > maxlength){
        let number = this.yearReqd;
        this.yearReqd = number.toString().substring(0, number.toString().length - 1);
      }
    },
  	resetCaptcha() {
    //   console.log("resetCaptcha");
      this.$refs.recaptcha.reset();
      this.recaptchaToken = "";
    },
    recaptchaVerified(token) {
    //   console.log("recaptchaVerified");
      if (token ) this.recaptchaToken = token;
  		// console.log("recaptchaToken="+ this.recaptchaToken);
      document.getElementById("showOtherResult").submit();
    },
  	showResult(){
  		// console.log("Click event triggered");
  		// console.log(this.amountReqd);
  		// console.log(this.yearReqd);

  		//Check for validation and collect data for calculations
  		//======================================================
  		let amountReqd = this.amountReqd;
  		let yearReqd = this.yearReqd;

  		if(amountReqd == "" || amountReqd == undefined || yearReqd == "" || yearReqd == undefined){
  			this.showErrorText = "Please enter mandatory data first";
  			this.showError = true;

  			// Check for mandatory fields
  			//==============================
  			if(amountReqd == "" || amountReqd == undefined){
  				this.amountReqdMClass = this.mandatoryClassName;
  			}else{
  				this.amountReqdMClass = "";
  			}

  			if(yearReqd == "" || yearReqd == undefined){
  				this.yearReqdMClass = this.mandatoryClassName;
  			}else{
  				this.yearReqdMClass = "";
  			}

  		}else{
  			//remove all redunderline class for mandatory
        //============================================
        this.amountReqdMClass = "";
        this.yearReqdMClass = "";
        
  			//Check all the basic validations eg.age, amt
				//=============================================
				axios.post('/chkOtherGoalValidations',{goalType: this.goalType, amountReqd: amountReqd, yearReqd: yearReqd, calcReq: 0, _token: this.$token})
        .then((response)=>{
        	// console.log(response);
        	let resData = response.data;
        	if(resData.status == true){
						this.showErrorText = "";
			    	this.showError = false;
        		// Show result on next page
					  //==================================================
						// this.$nextTick is added because above form is submitted before values changed in form
						//--------------------------------------------------------
				  	// this.$nextTick(() => {
				    		// Trigger clevertap event
					    	//===================================================
								// clevertap.event.push("Goal Calculator", {
								//   "page name": window.location.pathname,
								//   "Goal Type": this.goalType,
								//   "Corpus": amountReqd,
								//   "Year": yearReqd,
								// });

								//execute captcha call here
								//=========================================
								this.$refs.recaptcha.execute();
				   			
			    	// 	});
        	}else{
  					if(resData.error == undefined){
        			this.showErrorText = "Page session expired, Please refresh the page";
  						this.showError = true;
        		}else{
        			this.showErrorText = resData.error;
  						this.showError = true;
        		}

  					//Reset captcha called
			  		//=====================================
			  		this.resetCaptcha();
        	}
        }).catch(response => {
		        console.log(response.data);
		    })
  		}
  	},
  	resetCalculation(){
      // On keyup of field show button for calculation and hide result 
			//================================================================
			this.showErrorText = "";
    	this.showError = false;
    }
  },
};
</script>

<style lang="scss" scoped></style>
